<template>
  <v-container fluid>
    <br>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-transit-transfer
      </v-icon> Activities
    </h2>
    <br>
    <v-card
      shaped
      color="#CFD8DC"
    >
      <br>
      <v-card
        class="card-style"
        color="#ECEFF1"
        :style="getBgStyle"
      >
        <v-col class="text-right">
          <v-btn
            color="#FF3700"
            @click="showFilterForm = true"
          >
            Filter
          </v-btn>
          <v-btn
            fab
            dark
            outlined
            style="margin-left:10px;"
            color="#37474F"
            small
            @click="fetchUserActivities()"
          >
            <v-icon
              small
              dark
            >
              mdi-file-multiple-outline
            </v-icon>
          </v-btn>
        </v-col>
        <div class="no-file-alert">
          <h4 v-if="isActivityRecordsAvailable">
            No activity records found.
          </h4>
        </div>
        <v-timeline
          align-top
          dense
          light
        >
          <v-timeline-item
            v-for="(item, index) in userActivities"
            :key="index"
            color="#FF3700"
            small
            light
          >
            <v-row class="pt-1">
              <v-col>
                <strong class="font-my-style">Activity {{ index + 1 }}</strong>
                <br>
                <div>
                  <span
                    class="my-p-style"
                  >
                    Location:-
                    <font
                      class="font-my-style"
                    >
                      {{ item.site.name }}
                    </font>
                  </span><br>
                  <span
                    class="my-p-style"
                  >
                    Type:-
                    <font
                      class="type-style"
                    >
                      {{ item.type }}
                    </font>
                  </span><br>
                  <span
                    class="my-p-style"
                  >
                    Check-In Time:-
                    <font
                      class="font-my-style"
                    >
                      {{ item.checkin_time | convertToLocal }}
                    </font>
                  </span><br>
                  <span
                    v-if="item.checkout_time !== null"
                    class="my-p-style"
                  >
                    Check-Out Time:-
                    <font
                      class="font-my-style"
                    >
                      {{ item.checkout_time | convertToLocal }}
                    </font>
                  </span>
                  <span
                    v-else
                    class="my-p-style"
                  >
                    Check-Out Time:-
                    <font
                      class="not-checked-out-style"
                    >
                      Active*
                    </font>
                  </span>
                </div>
              </v-col>
            </v-row>
          </v-timeline-item>
        </v-timeline>
      </v-card>
      <div class="py-3" />
    </v-card>
    <centre-spinner
      :loading="loading"
    />
    <filter-user-activities
      v-if="showFilterForm"
      @closed="showFilterForm=false"
    />
  </v-container>
</template>
<script>
  import spinner from 'src/views/components/SpinnerCentre';
  import moment from 'moment';
  import FilterUserActivities from './FilterUserActivities.vue';

  export default {
    name: 'UserActivities',
    components: {
      'centre-spinner': spinner,
      'filter-user-activities': FilterUserActivities,
    },
    filters: {
      convertToLocal (stringDatetime) {
        return moment(stringDatetime).local().format('Do MMMM YYYY hh:mm A');
      },
      displayHighRisk (status) {
        if (status === true) {
          return 'Yes*';
        } else {
          return 'No';
        }
      },
    },
    data () {
      return {
        search: '',
        loading: false,
        showForm: false,
        cardBgImg: require('@/assets/img/cardBg.png'),
        showFilterForm: false,
      };
    },
    computed: {
      userActivities () {
        const list = this.$store.getters['userprofile/getUserActivities'];
        const sortedList = list.sort((a, b) => {
          return new Date(b.created_at) - new Date(a.created_at);
        });
        return sortedList;
      },
      getBgStyle () {
        return `background-image: linear-gradient(rgba(255,255,255,.6), rgba(255,255,255,.6)), url(${this.cardBgImg});`;
      },
      isActivityRecordsAvailable () {
        if (this.userActivities.length === 0) {
          return true;
        }
        return false;
      },
    },
    async mounted () {
      await this.fetchUserActivities();
    },
    methods: {
      async fetchUserActivities () {
        this.loading = true;
        await this.$store.dispatch('userprofile/fetchUserActivities');
        this.loading = false;
      },
      getStatusColor (status) {
        if (status === 'completed') {
          return '#2E7D32';
        } else {
          return '#C62828';
        }
      },
      getHrwColor (value) {
        if (value === true) return '#C62828';
        else { return '#2E7D32'; }
      },
    },
  };
</script>
<style scoped>
.font-my-style {
  font-weight: bold;
  font-size: 12px;
  color: #37474F;
  text-transform: capitalize;
}
.my-p-style {
  font-size: 12px;
  font-weight: bold;
  color: #546E7A;
  font-family:Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
}
.not-checked-out-style {
  font-weight: bold;
  font-size: 12px;
  color: #2E7D32;
}
.type-style {
  font-weight: bold;
  font-size: 12px;
  color: #FF3700;
  text-transform: capitalize;
}
.title-style {
  color: #37474F;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.card-style {
  margin-left: 5px;
  margin-right: 5px;
  padding-top: 25px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.no-file-alert {
  color: #C62828;
  font-size: 18px;
  text-align: center;
  font-family: 'Times New Roman', Times, serif;
  margin-bottom: 50px;
  margin-top: 50px;
}
</style>
